'use client';

import type { SearchResult } from 'conversational-search-client';
import { type JSX } from 'react';

import { JustifiedGallery } from '@videoblocks/design-system';

import { VideoResultCard } from './VideoResultCard';
import { deriveAspectRatio } from './deriveAspectRatio';

interface VideoResultsGridProps {
    results: SearchResult[];
}

export function VideoResultsGrid({ results }: VideoResultsGridProps): JSX.Element {
    const items = results.map((result) => ({
        ...result,
        id: result.contentId,
        aspectRatio: deriveAspectRatio(result.orientation),
    }));

    return (
        <div className="flex flex-col gap-3 p-4">
            <JustifiedGallery items={items} rowGapPx={8} columnGapPx={8}>
                {({ item }) => <VideoResultCard result={item} />}
            </JustifiedGallery>
        </div>
    );
}
